import { tsValidateArray, tsValidateNumber, tsValidateString, tsValidateTimestamp } from '@nu-art/ts-common';
const Validator_ModifiableProps = {
    timestamp: tsValidateTimestamp(),
    backupPath: tsValidateString(),
    firebasePath: tsValidateString(),
    metadataPath: tsValidateString(),
    metadata: {
        timestamp: tsValidateTimestamp(),
        collectionsData: tsValidateArray({
            dbKey: tsValidateString(),
            numOfDocs: tsValidateNumber(),
            version: tsValidateString()
        })
    }
};
const Validator_GeneratedProps = {};
export const DBDef_BackupDoc = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'firestore-backup-status-v2',
    entityName: 'firestoreBackupStatus',
    frontend: {
        group: 'app',
        name: 'firestore-backup-status-v2'
    },
    backend: {
        name: 'backup-doc'
    }
};
//# sourceMappingURL=db-def.js.map